import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'lg',
    fullName: 'Ganda',
    nativeName: 'Luganda',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid nga bwe kiri",
    landing_title: "Ekintu Ekyewuunyisa Kijja",
    landing_subtitle: "ArgVoid ye situdiyo ekola app n'emizannyo. Lindirira, ebintu ebipya bijja mu bbanga ttono!",
    select_language: "Londa Olulimi",
    search_placeholder: "Noonya ennimi...",
    terms_title: "Ebiragiro by’Empeereza",
    policy_title: "Enkola y’Ebyama",
    cookies_title: "Enkola ya Kuki",
    terms_content: `
        <strong>1. Okukkiriza Ebiragiro</strong><br>
        Bw’oyingira mu ArgVoid, Ebiragiro bino eby’Empeereza bikkirizibwa. Singa ebiragiro bino tebikkiriziganyiziddwaako, empeereza tesaana kukozesebwa.<br><br>

        <strong>2. Enkozesa y'omukutu</strong><br>
        ArgVoid n'enkola zaayo ziweebwa "nga bwe ziri" olw'ebigendererwa by'amawulire n'okuyiiya. Empeereza erina okukozesebwa ku nsonga ezikkirizibwa zokka.<br><br>

        <strong>3. Empisa ezikugirwa</strong><br>
        Okukozesa obuzibu bw’omukutu, okuwandiika obubaka obutaliimu, oba okugezaako okuyingira mu bikozesebwa nga tolina lukusa kikugirwa nnyo.<br><br>

        <strong>4. Okwegaana</strong><br>
        Omukutu n’empeereza biyinza okukyusibwa ekiseera kyonna awatali kutegeeza. Tewali ggaranti eweebwa ku bikwata ku budde bw’okukola oba okubeerawo kw’empeereza.
    `,
    policy_content: `
        <strong>1. Okukunganya Amawulire</strong><br>
        Omukutu guno tekyetaagisa kukakasa bakozesa oba okukola akawunti mu kiseera kino. Tewali bikwata ku muntu (nga amannya oba endagiriro za email) ebikunganyizibwa mu bujjuvu okuva mu bakyazi.<br><br>

        <strong>2. Enkozesa Data</strong><br>
        Okwekenenya okusookerwako, okutamanyiddwa mannya kuyinza okukunganyizibwa okutegeera entambula y’omukutu n’okulongoosa enkola. Data eno tekwatagana na ndagamuntu za bakozesa ssekinnoomu.<br><br>

        <strong>3. Empeereza z’abantu ab’okusatu</strong><br>
        Abagaba eby’okusatu bayinza okukozesebwa mu mpeereza z’okukyaza n’okwekenneenya. Enkola z’ekyama ez’abagaba bano abakwatibwako zifuga data ezitamanyiddwa mannya ezikolebwa ku bikozesebwa byabwe.<br><br>

        <strong>4. Obukuumi bwa Data</strong><br>
        Ebintu ebituufu eby’obukuumi biteekebwa mu nkola okukuuma omukutu guno. Naye tewali ngeri yonna ya kutambuza ku yintaneeti eriko bukuumi bwonna.<br><br>
    `,
    cookies_content: `
        <strong>1. Kuki n’okutereka mu kitundu kye ki?</strong><br>
        Kuki n'okutereka mu kitundu kya browser ze fayiro za data entono eziterekeddwa ku kyuma okujjukira eby'okusengeka eby'enjawulo mu kukyalira.<br><br>

        <strong>2. Ekigendererwa ky'okukozesa</strong><br>
        Browser LocalStorage ekozesebwa nnyo okutereka ensengeka z'okusengeka, nga:<br>
        - Okwagala olulimi<br>
        - Ensengeka y'enkolagana y'omukozesa (e.g., ensengeka oba ensengeka y'omulamwa)<br>
        - Cache y'okukozesa ey'ekiseera<br><br>

        <strong>3. Tewali Kulondoola</strong><br>
        Kuki n’okutereka mu kitundu tebikozesebwa kulanga oba kulondoola bantu ba kusatu. Data yonna eterekeddwa eri strictly for the core functionality ya platform.<br><br>

        <strong>4. Okufuga</strong><br>
        Data ya browser esobola okulongoosebwa ekiseera kyonna okuyita mu nteekateeka za browser, ezijja okuddamu okuteekawo ensengeka zonna ez’omu kitundu.
    `,
    cookie_consent_text: "Tukozesa kukisi ezisookerwako okukakasa nti omukutu guno gukola bulungi, gamba ng’okukuuma olutuula lwo nga lukola, okutereka olulimi lw’oyagala, n’ensengeka endala ez’enjawulo.",
    read_policy: "Soma Enkola ya Kuki",
    support_title: "Tuukirira Obuwagizi",
    support_subject_label: "Essomo",
    support_message_label: "Obubaka",
    support_submit_button: "Weereza Obubaka",
    support_hint: "Note: Kino kijja kuggulawo enkola yo eya email esookerwako okuweereza obubaka.",
    support_success_msg: "Okuggulawo app yo eya email...",
    support_error_msg: "Eremereddwa okuweereza obubaka. Nsaba oddemu ogezeeko oluvannyuma.",
    explorer_title: "Omunoonyereza",
    history_title: "Ebyafaayo",
    animation_title: "Ebifaananyi ebirina obulamu",
    config_title: "Okusengeka",
    tool_mouse: "Londa (Ctrl+M) .",
    tool_brush: "Bbulawuzi (Ctrl+B) .",
    tool_brush_mode: "Toggle Mode (Ekalu/Etangaavu) .",
    tool_eraser: "Ekyuma ekisangula (Ctrl+E) .",
    tool_brush_size: "Teekateeka Sayizi ya Bbulawuzi",
    tool_bucket: "Jjuza (Ctrl+F) .",
    tool_eyedropper: "Ekyuma ekikuba amaaso",
    tool_grid: "Grid (Ctrl+Okukyusa+B) .",
    tool_rotate: "Zingulula (Ctrl+Shift+R) .",
    tool_flip_h: "Flip H (Ctrl+Okukyusa+H) .",
    tool_flip_v: "Flip V (Ctrl+Okukyusa+V) .",
    tool_transpose: "Okukyusa (Ctrl+Okukyusa+T) .",
    label_width: "Obugazi",
    label_height: "Obuwanvu",
    label_frames: "Omuwendo gwa Fuleemu",
    label_animation: "Omusono gw'okukola Animation",
    label_background_color: "Langi y'emabega",
    label_interval: "Interval",
    tool_anim_config: "Ensengeka y'ebifaananyi ebirina obulamu",
    label_new_width: "Obugazi Obupya",
    label_new_height: "Obugulumivu Obupya",
    label_apply: "Okuteeka mu nkola",
    label_colors: "Langi za langi",
    label_size: "Obunene",
    label_tolerance: "Obuguminkiriza",
    val_horizontal: "Okwegolola",
    val_vertical: "Okwesimba",
    val_sequence: "Olunyiriri",
    val_bounce: "Okubuuka",
    val_random: "Okulonda okutalimu okwekubila",
    val_solid: "Ekigumu",
    val_clear: "Okumalawo",
    action_add_sheet: "Olupapula Olupya",
    action_import: "Okuyingiza",
    action_export: "Okufulumya",
    action_sort_projects: "Engeri",
    sort_date_old: "Ekisinga Obukulu Okusooka",
    sort_date_new: "Ebipya Okusooka",
    sort_name_az: "Erinnya (A-Z) .",
    sort_name_za: "Erinnya (Z-A) .",
    action_new_sprite: "Sprite empya",
    action_new_project: "Pulojekiti Empya",
    modal_save_all_title: "Teeka Enkyukakyuka Zonna",
    modal_save_all_desc: "Londa eby'obugagga by'ogenda okutereka:",
    modal_save_selected: "Teeka Ebirondeddwa",
    action_saved: "Kiterekeddwa",
    modal_create_sprite_title: "Tonda Sprite Empya",
    modal_create_project_title: "Tonda Pulojekiti Empya",
    modal_add_sheet_title: "Okwongerako Olupapula Olupya",
    modal_rename_sheet_title: "Kyuusa erinnya ly’Olupapula",
    modal_rename_sprite_title: "Kyuusa erinnya lya Sprite",
    modal_delete_sprite_title: "Ssazaamu Sprite",
    modal_delete_project_title: "Ssaako Pulojekiti",
    modal_delete_sheet_title: "Ssaako Olupapula",
    placeholder_sprite_name: "Erinnya",
    placeholder_project_name: "Erinnya",
    placeholder_sheet_name: "Erinnya",
    placeholder_new_name: "Erinnya Eppya",
    action_create: "Okutonda",
    action_add: "Okwongerako",
    action_rename: "Kyuusa erinnya",
    action_duplicate: "Okukoppa",
    action_delete: "Okusiimuula",
    action_cancel: "okusazaamu",
    confirm_delete_sprite: "Okakasa nti oyagala kusazaamu sprite eno?",
    confirm_delete_project: "Okakasa nti oyagala kusazaamu pulojekiti eno? Sprites zonna zijja kuggyibwawo.",
    confirm_delete_sheet: "Okakasa nti oyagala kusazaamu lupapula luno?",
    err_select_sprite: "Nsaba osooka kulonda sprite.",
    err_select_project: "Nsaba osooke olonde pulojekiti.",
    err_name_empty: "Erinnya teriyinza kuba bwereere.",
    err_sprite_exists: "Sprite eriko erinnya eryo eriwo dda.",
    err_project_exists: "Pulojekiti eriko erinnya eryo eriwo dda.",
    err_no_content: "Tewali birimu kutereka.",
    err_no_changes: "Tewali nkyukakyuka za kutereka.",
    err_delete_last_sheet: "Tesobola kusazaamu lupapula olusembayo.",
    err_extract_frames: "Teyasobodde kuggyamu fuleemu yonna.",
    err_indexeddb: "Eremereddwa okutereka mu kitundu. Browser yo eyinza obutawagira IndexedDB.",
    msg_upload_success: "Okuteeka ku mukutu Kuwangudde: {0}",
    msg_upload_failed: "Okuteeka ku mukutu Kulemereddwa: {0}",
    msg_save_success: "Save successful.",
    msg_saving: "Okutereka...",
    msg_multi_save_result: "Eby'obugagga {0} ebiterekeddwa. {1} okulemererwa.",
    menu_title: "Menyu",
    menu_save: "Okununula",
    menu_save_all: "Taasa Byonna",
    menu_support: "Tuukirira Obuwagizi",
    label_local_storage: "Okutereka mu kitundu",
    label_sign_in: "Yingira mu",
    modal_export_title: "Okufulumya ebweru Sprite",
    label_filename: "Erinnya lya fayiro",
    label_format: "Enkola y’okukola",
    action_export_confirm: "Okufulumya",
};

export default translations;
